<template>
  <div :class="[$style.drawer, { [$style.active]: isActive }]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    isActive: {
      default: true,
      required: false,
      type: Boolean
    }
  }
};
</script>

<style module>
.drawer {
  bottom: 0;
  left: 0;
  margin: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: left 0.25s, margin 0.25s, opacity 0.25s;
  will-change: left, margin, opacity;
  z-index: 10;
}

.drawer.active {
  left: 0 !important;
  margin: 0 !important;
  opacity: 1 !important;
}
</style>
